(function CART(MD) {
  

  /*****************************************
   SET ENVIRONMENT
  *****************************************/

  
  let cartData, config, publicAPI;

  const init = function () {
    config = JSON.parse(document.querySelector('[data-cart-config]').innerHTML);
    cartData = JSON.parse(document.querySelector('[data-cart-data]').innerHTML);
    publicAPI = getAPI(cartData, config);
    setVariables();
    setEvents();
    return publicAPI;
  };

  MD.cart = init();


  /*****************************************
   SET VARIABLES & EVENTS
  *****************************************/


  /**
   * create section object
   * @param {Object} cart settings
   * @return {Object} snippet object
   */
  function getAPI(cartData, config) {
    return {
      cartData,
      config,
      addToCart,
      changeCart,
      init
    };
  }

  /**
   * set variables in global obj
   */
  function setVariables() {
    publicAPI.selectors = {
      price: {
        subtotal: document.querySelector('.summary__price--subtotal'),
        total: document.querySelector('.summary__price--total'),
        delivery: document.querySelector('.summary__price--delivery'),
        savings: document.querySelector('.summary__savings--price')
      },
      discount: {
        remove: document.querySelector('.summary__total--discount-tag svg.summary__total--discount-close'),
        title: document.querySelector('.summary__total--discount-title'),
        text: document.querySelector('.cartDiscount__text'),
        price: document.querySelector('.summary__price--discount'),
        field: document.querySelector('.cartDiscount'),
        btn: document.querySelector('.cartDiscount button'),
        fieldInput: document.querySelector('.cartDiscount input:not([type=hidden]'),
        submitInput: document.querySelector('.cartDiscount input[name=discount]'),
      },
      upsell : {
        wrapper: document.querySelector('.upsell-treshold__wrapper'),
        progress: document.querySelector('.upsell-treshold__progress'),
        text: document.querySelector('.upsell-treshold__text'),
        goalText: document.querySelector('.upsell-treshold__text span')
      },
      section: document.querySelector('section.cart-MD'),
      timer: document.querySelector('#cdTimerCart'),
      cartItems: document.querySelectorAll('.cartItems__container'),
      qtyButtons: document.querySelectorAll('.cartItems__quantity--controls'),
      qtyDropdown: document.querySelectorAll('.cartItems__quantity .quantity-dropdown'),
      removeItems: document.querySelectorAll('.cartItems__close, .cartItems__bin'),
      summaryDetails: document.querySelector('.summary__total--details'),
      summarySavings: document.querySelector('.summary__savings'),
      stickyATC: document.querySelector('.btnCart__sticky'),
      btnATC: document.querySelector('.btnCart'),
      terms: document.querySelector('.cart__terms'),
      sentinelBottom: document.querySelector('.cart__sentinel--bottom'),
      cartMessageWrapper: document.querySelector('.cartMessage__wrapper'),
      cartCount: document.querySelectorAll(config.cartCountSelector),
      cartIndication: document.querySelectorAll(config.cartIndicationSelector)
    };
    publicAPI.classes = {
      removeItem: 'cartItems__container--remove',
      btnShadow: 'btnCart__sticky--shadow',
      btnLoading: 'btnCart--loading',
      discountLoading: 'discount__svg--loading',
      summaryTotalDetails: 'summary__total--details-discount',
      hidePromoField: 'cartDiscount__hidden',
      hideMsgBar: 'cartMessage__wrapper--hidden',
      hideSavings: 'summary__savings--hidden',
      hideProgressBar: 'upsell-treshold__bar--hidden',
      claimUpsell: 'upsell-treshold__wrapper--claim',
      cartLoading: 'cart-loading',
      cartIndicationOn: config.cartIndicationOn,
      cartIndicationOff: config.cartIndicationOff,
    };     
  }

  /**
   * Start cart events
   */
  function setEvents() {
    if(cartData.item_count > 0) {
      onInit();
      onUpdateQty(); /* update cart quantity on quantity click */
      onSubmitCart(); /* button loader on cart submit */
      onSubmitDiscount(); /* apply discount on cart page */
      onCookieDiscount(); /* reset previous discount code within 1 hour */
      onRemoveDiscount(); /* remove discount promotion on close action */
      onClaimUpsell(); /* add upsell to cart when button clicked */
      onCdTimer(); /* Countdown timer with cookie deposit */
    }
  }


  /*****************************************
   ON CART INIT
  *****************************************/


  /**
   * On init
   */
  function onInit() {
    if (config.discount.qtyManual) solveSwapCart();
    formatMoney();
    if (config.upsell.treshold && !config.upsell.manual) updateUpsell(); /* update upsell on cart init */
    observeStickyBtn(); /* ATC sticky shadow on mobile */
    iosFixes(); /* ios fix when returning from checkout */
    updateCount(); /* update count selector */
    discountBtnStatus(); /* enable or disable discount btn */
  }


  /**
   * ATC sticky shadow on mobile
   */
  function observeStickyBtn() {
    let observer = new IntersectionObserver(entry => {
      if(entry[0].target == publicAPI.selectors.sentinelBottom) {
        if (entry[0].isIntersecting ) {
          publicAPI.selectors.stickyATC.classList.remove(publicAPI.classes.btnShadow);
        } else {
          publicAPI.selectors.stickyATC.classList.add(publicAPI.classes.btnShadow);
        }
      }
    });
    publicAPI.selectors.sentinelBottom &&
      observer.observe(publicAPI.selectors.sentinelBottom);
  }


  /**
   * ios fix when returning from checkout
   */
  function iosFixes() {
    window.onpageshow = function(event) {
      if(event.persisted) {
        publicAPI.selectors.btnATC.classList.remove(publicAPI.classes.btnLoading);
      }
    };
  }


  /**
   * enable or disable discount btn
   * @loading {boolean} - discount btn loading animation
   */
  function discountBtnStatus(loading = false) {
    if(!config.discount.auto && publicAPI.selectors.discount.fieldInput) {
      if (loading) {
        publicAPI.selectors.discount.btn.classList.add(publicAPI.classes.discountLoading);
        setTimeout(function() {
          publicAPI.selectors.discount.fieldInput.value = '';
          publicAPI.selectors.discount.btn.disabled = true;
          publicAPI.selectors.discount.btn.classList.remove(publicAPI.classes.discountLoading);
          publicAPI.selectors.discount.field.classList.add(publicAPI.classes.hidePromoField);
        }, 750);
        return;
      }
      publicAPI.selectors.discount.fieldInput.addEventListener('keyup', function(event) {
        this.nextElementSibling.disabled = this.value == '' ? true : false;
        publicAPI.selectors.discount.submitInput.value = publicAPI.selectors.discount.fieldInput.value;
        if (event.keyCode === 13) {
          event.preventDefault();
          publicAPI.selectors.discount.btn.click();
        }
      });
    }
  }


  /**
   * money formater.
   */
  function formatMoney() {
    let Shopify = window.Shopify || {};
    Shopify.money_format = config.moneyFormat,Shopify.formatMoney=function(a,g){function d(a,b){return a===void 0?b:a;}function c(a,c,e,f){if(c=d(c,2),e=d(e,','),f=d(f,'.'),isNaN(a)||a==null)return 0;a=(a/100).toFixed(c);var b=a.split('.'),g=b[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+e),h=b[1]?f+b[1]:'';return g+h;}typeof a=='string'&&(a=a.replace('.',''));var b='';var e=/\{\{\s*(\w+)\s*\}\}/;var f=g||this.money_format;switch(f.match(e)[1]){case'amount':b=c(a,2);break;case'amount_no_decimals':b=c(a,0);break;case'amount_with_comma_separator':b=c(a,2,'.',',');break;case'amount_no_decimals_with_comma_separator':b=c(a,0,'.',',');break;}return f.replace(e,b);};
    Object.defineProperty(Shopify, "money_format", { configurable: false, writable: false });
    Object.defineProperty(Shopify, "formatMoney", { configurable: false, writable: false });
  }


  /*****************************************
   ON USER INTERACTION
  *****************************************/


  /**
   * update cart quantity on quantity click
   * 1 > Mobile selector
   * 2 > Increment / decrement buttons
   * 3 > Bin / cross
  */
  function onUpdateQty() {
    for (let select of publicAPI.selectors.qtyDropdown) { 
      select.addEventListener('change', function(e) {
        let item = e.target.closest('[data-item-line]');
        let qty = parseInt(select.value, 10);
        let qtyMax = +e.target.dataset.quantityMax;
        if(!qtyMax || qty <= qtyMax) {
          select.previousElementSibling.querySelector('input').value = qty;
          item.dataset.itemQty = qty;
          changeCart(qty, item);
        } else {
          alert(publicAPI.config.inventoryAlert);
          cartLoader();
          cartRefresh();
        }
      });
    }
    for (let button of publicAPI.selectors.qtyButtons) {
      let input = button.querySelector('input');
      button.addEventListener('click', function(e) {
        if(monitorClicks(e)) {
          let item = e.target.closest('[data-item-line]');
          let qty = parseInt(input.value, 10);
          if (e.target.hasAttribute('data-decrement')) {
            qty = isNaN(qty) ? 0 : qty;
            qty--;
            input.value = qty;
            item.dataset.itemQty = qty;
            button.nextElementSibling.value = qty;
            changeCart(qty, item);
          } else if (e.target.hasAttribute('data-increment')) {
            let qtyMax = +e.target.dataset.quantityMax;
            qty = isNaN(qty) ? 0 : qty;
            qty++;
            if(!qtyMax || qty <= qtyMax) {
              input.value = qty;
              item.dataset.itemQty = qty;
              button.nextElementSibling.value = qty;
              changeCart(qty, item);
            } else {
              alert(publicAPI.config.inventoryAlert);
              cartLoader();
              cartRefresh();
            }
          }
        }
      });
    }
    publicAPI.selectors.removeItems.forEach(function(el) {
      el.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        let item = event.target.closest('[data-item-line]');
        item.dataset.itemQty = 0;
        changeCart(0, item);
      });
    });
  }


  /**
   * button loader on cart submit
   * fetch('https://domain.name/cart.json').then((resp) => resp.json()).then(console.log)
   */
  function onSubmitCart() {
    document.addEventListener('click', function(e) {
      if (publicAPI.selectors.btnATC.contains(e.target)) {
        let allowSubmit = !publicAPI.selectors.terms || publicAPI.selectors.terms.querySelector('input').checked;
        if (allowSubmit) {
          publicAPI.selectors.btnATC.classList.add(publicAPI.classes.btnLoading);
          if (config.appsDisable != 'default') {
            e.preventDefault(); 
            e.stopImmediatePropagation();
            window.location.href = publicAPI.selectors.discount.submitInput?.value != ''
            ? '/checkout?discount=' + publicAPI.selectors.discount.submitInput.value
            : '/checkout'
          }
        }
      }
    }, config.appsDisable == 'force_2' ? true : false);
  }


  /**
   * apply discount on cart page
   */
  function onSubmitDiscount() {
    if (!config.discount.auto) {
      if(config.discount.custom) {
        publicAPI.selectors.discount.btn.addEventListener('click', function() {
          for (const [discount, codes] of Object.entries(config.discount.discounts)) {
            for (let code of codes) {
              if(code == publicAPI.selectors.discount.fieldInput.value) {
                publicAPI.selectors.discount.submitInput.value = publicAPI.selectors.discount.fieldInput.value;
                publicAPI.cartData.custom_discount = +discount;
                discountBtnStatus(true);
                cookieDiscount(true, code, discount);
                setTimeout(function() {updateSummary(true, true);}, 750);
                return;
              }
            }
          }
          discountWarning(publicAPI.cartData.original_total_price);
        });
      } else {
        publicAPI.selectors.discount.fieldInput.addEventListener('focus', function() {
          discountWarning(publicAPI.cartData.original_total_price);
        });
      }
      /* default behaviour */
      function discountWarning(cartValue) {
        publicAPI.selectors.discount.text.classList.add('show');
        publicAPI.selectors.discount.btn.disabled = true;
        publicAPI.selectors.discount.submitInput.value = publicAPI.selectors.discount.fieldInput.value;
        updateSummary(false);
      }
    }
  }


  /**
   * reset previous discount code within 1 hour
   */
  function onCookieDiscount() {
    if (!config.discount.auto && config.discount.custom) {
      if(document.cookie.match(/^(.*;)?\s*discountCode\s*=\s*[^;]+(.*)?$/)) {
        let code = JSON.parse(getCookie('discountCode'))[0];
        let discount = JSON.parse(getCookie('discountCode'))[1];
        publicAPI.selectors.discount.submitInput.value = code;
        publicAPI.cartData.custom_discount = +discount;
        updateSummary();
      } else if (document.cookie.match(/^(.*;)?\s*discount_code\s*=\s*[^;]+(.*)?$/)) {
        let discount_code = getCookie('discount_code');
        for (const [discount, codes] of Object.entries(config.discount.discounts)) {
          for (let code of codes) {
            if(code.toUpperCase() == discount_code.toUpperCase()) {
              publicAPI.selectors.discount.submitInput.value = code;
              publicAPI.cartData.custom_discount = +discount;
              discountBtnStatus(true);
              updateSummary(true, true);
              return;
            }
          }
        }
      }
    }
  }


  /**
   * remove discount promotion on close action
   */
  function onRemoveDiscount() {
    if(publicAPI.selectors.discount.remove) {
      publicAPI.selectors.discount.remove.addEventListener('click', function() {
        publicAPI.selectors.discount.submitInput.value = '';
        publicAPI.cartData.custom_discount = 0;
        updateSummary(false);
        cookieDiscount(false);
      });
    }
  }


  /**
   * add upsell when claimed
   */
  function onClaimUpsell() {
    if(config.upsell.treshold) {
      publicAPI.selectors.upsell.wrapper.addEventListener('click', function(e) {
        if (e.currentTarget.classList.contains(publicAPI.classes.claimUpsell)) {
          addToCart([{"quantity": 1, "id": config.upsell.id, properties: config.upsell.prop}], cartRefresh, true);
        }
      }, { once : true} );
    }
  }


  /**
   * run cdTimer with cookies (needs rebuild)
   */
  function onCdTimer() {
    if(config.cdTimer.enabled) {
      var totalTime = config.cdTimer.time*60*1000;
      if(!document.cookie.match(/^(.*;)?\s*cdTime\s*=\s*[^;]+(.*)?$/) && publicAPI.selectors.timer != null) {
        var firstTime = new Date();
        function cookieTimer(cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + (exdays*60*1000) + totalTime);
          var expires = config.cdTimer.expiry == 0 ? ";" : ";expires="+ d.toUTCString();
          document.cookie = cname + "=" + cvalue + expires + "path=/";
        }
        cookieTimer('firstTime', firstTime, config.cdTimer.expiry);
        cookieTimer('cdTime', totalTime, config.cdTimer.expiry);
        var deadline = new Date(Date.parse(new Date()) + totalTime);
        initializeClock('cdTimerCart', deadline);
      } else if (publicAPI.selectors.timer != null) {
        var firstTimeValue = Date.parse(document.cookie.replace(/(?:(?:^|.*;\s*)firstTime\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
        var currentTime = Date.parse(new Date());
        var usedTime = (currentTime - firstTimeValue);
        var runTimer = new Date(Date.parse(new Date()) + (totalTime - usedTime));//new deadline after time has passed
        initializeClock('cdTimerCart', runTimer);
      }
      function getTimeRemaining(endtime) {
        var t = Date.parse(endtime) - Date.parse(new Date());
        var seconds = Math.floor((t / 1000) % 60);
        var minutes = Math.floor((t / 1000 / 60) % 60);
        var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        var days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
          'total': t,
          'days': days,
          'hours': hours,
          'minutes': minutes,
          'seconds': seconds
        };
      }
      function initializeClock(id, endtime) {
        var clock = document.getElementById(id);
        var minutesSpan = clock.querySelector('#cart_minutes');
        var secondsSpan = clock.querySelector('#cart_seconds');
        var pageLoad = true;
        function updateClock() {
          var t = getTimeRemaining(endtime);
          minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
          secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
          //reset timer when days > 0
          if (t.total <= 0 || isNaN(t.total)) {
            clearInterval(timeinterval);
            if (publicAPI.selectors.timer.nextElementSibling && publicAPI.selectors.timer.nextElementSibling.nodeName == 'HR') {
              publicAPI.selectors.timer.nextElementSibling.remove();
            }
            publicAPI.selectors.timer.remove();
          } else if(pageLoad) {
            publicAPI.selectors.timer.classList.add('cdTimerCart--active');
            pageLoad = false;
          }
        }
        updateClock();
        var timeinterval = setInterval(updateClock, 1000);
      }
    }
  }


  /*****************************************
   ADD, CHANGE, RENDER, SWAP, UPDATE CART
  *****************************************/


  /**
   * add to cart and call renderCart
   * @qty {number} - updated qty of line item
   * @variantID {number} - product variant ID
   * @properties {json} - product properties
   * @callback {function} - ATC Action
   * @loader {boolean} - cart loader animation
   */
  function addToCart(data, callback, loader) {
    if (loader) cartLoader();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ "items": data })
    })
    .then(response => response.json())
    .then(callback)
    .catch(console.error)
  }

  
  /**
   * update cart and call renderCart
   * @line {string} - line of product
   * @qty {number} - updated qty of line item
   * @key {object} - variant key
   * @allowSwap {boolean} - allow cartSwap feature
   */
  function changeCart(qty, item, key, allowSwap = true) {
    if(qty == 0) {
      cartLoader();
    } else if (config.discount.qtyManual && item.dataset.offerId && allowSwap) {
      solveSwapCart(qty, item, key);
      return;
    }
    // change line item
    let bodyData = item ? {"quantity": qty, "line": item.dataset.itemLine } : {"quantity": qty, "id": key } 
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bodyData)
    })
    .then(data => data.json())
    .then((newCart) => {
      let reloadCart = solveReloadCart(qty, newCart);
      if (!reloadCart) renderCart(qty, item);
    })
    .catch(console.error);
  }
  

  /**
   * cart rendering
   * @line {string} - line of product 
   * @qty {number} - updated qty of line item
   */
  function renderCart(qty, item) {
    // update cart count
    updateCount();
    // update upsell treshold
    config.upsell.treshold && updateUpsell();
    // update line item prices
    updateLineItems(qty, item);
    // update summary price
    updateSummary();
  }


  /**
   * permute variants with their matching Discount option
   * 1 - loop through all discounted items
   * 2 - loop through their variants
   * 3 - push matching variant to array (based on new discount option)
   * 4 - remove current variant and add new variant
   * @qty {number} - updated qty of line item
   * @line {string} - line of product
   * @qtyOffer {object} - DOM node / qty offer json
   */
  function swapCart(offerId, promoValue) {
    let allItems = [...publicAPI.selectors.cartItems];
    let promoItems = allItems.filter(el => +el.dataset.offerId == offerId);
    let promoIndex = +promoItems[0].dataset.discountPosition;
    let variantsToAdd = [];

    // build array of variants to add
    for (let item of allItems) {
      if (item.dataset.offerId == offerId) {
        let itemData = JSON.parse(item.querySelector('[data-variant]').textContent); 
        let currentOptions = itemData.currentOptions;
        let variants = itemData.variants;

        for (let variant of variants) {
          if (variant.options.includes(promoValue)) {
            // remove promo option to find matching variant
            variant.options.splice(promoIndex, 1);
            currentOptions.splice(promoIndex, 1);

            if (variant.options.every(option => currentOptions.includes(option))) {
              variantsToAdd.push({
                quantity: +item.dataset.itemQty,
                id: variant.id
              })
            }
          }
        }
      } else {
        variantsToAdd.push({
          quantity: +item.dataset.itemQty,
          id: +item.dataset.itemId
        })
      }
    }

    // clear cart and rebuild it
    resetCart(variantsToAdd.reverse());
  }

  
  /**
   * update cart and call renderCart
   * @line {string} - line of product
   * @qty {number} - updated qty of line item
   */
  function resetCart(variantsToAdd) {
    fetch('/cart/clear.js', { method: 'POST' })
    .then(response => response.json())
    .then((cart) => {
      if (variantsToAdd.length) {
       addToCart(variantsToAdd, cartRefresh, true);
      }
    })
    .catch(console.error);
  }


  /*****************************************
   UTILITY FUNCTIONS
  *****************************************/
 
  
  /**
   * prevent too many click on quantity buttons
   * @event {object} - event triggered on qty increment or decrement
   */
  let lastClick, diffTime;
  function monitorClicks(event) {
    if (lastClick) {
      diffTime = event.timeStamp - lastClick;
      if (diffTime >= 400) {
        lastClick++;
      } else {
        console.warn('Too many simultaneous requests');
        return false;
      }
    }
    lastClick = event.timeStamp;
    return true;
  }


  /**
   * get cookie value by name
   * @name {string} - name of cookie (key)
   */
  function getCookie(name) {
    let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  }

  
  /**
   * set 1hr cookie when custom discount is added.
   */
  function cookieDiscount(exist, code, discount) {
    if(exist) {
      let date = new Date();
      date.setTime(date.getTime()+(60*60*1000));
      document.cookie = `discountCode=${JSON.stringify([code, discount])}; expires=${date.toUTCString()}; path=/`;
    } else {
      document.cookie = 'discountCode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    }
  }


  /**
   * update cart and call renderCart
   * @qty {number} - updated qty of line item
   * @newCart {object} - updated cart object
   */
  function solveReloadCart(qty, newCart) {
    // reload if auto discount status has changed
    const wasAutoDiscount = publicAPI.cartData.total_discount > 0;
    Object.assign(publicAPI.cartData, newCart);
    const isAutoDiscount = newCart.total_discount > 0;
    if (isAutoDiscount && !wasAutoDiscount || !isAutoDiscount && wasAutoDiscount) {
      cartRefresh();
      return true;
    }
    // remove discounted upsell if upsell trigger was removed & reload cart if qty is 0 
    if(qty == 0) {
      for(let item of publicAPI.cartData.items.values()) {
        if(item.properties._url_original) {
          let originalItemInCart = Object.values(publicAPI.cartData.items).find(function(originalItem) {
            return item.sku == originalItem.sku && !originalItem.properties._url_original
          });
          if(!originalItemInCart) {
            changeCart(0, null, item.key, false);
            return true;
          }
        }
      }
      // reload cart
      cartRefresh();
      return true;
    }
    return false;
  }
  
  
  /**
   * check if we need to swapCart()
   * @qty {number} - updated qty of line item
   * @line {string} - line of product
   * @key {object} - variant key
   */
  function solveSwapCart(qty, item, key) {

    let offerItems = item 
    ? document.querySelectorAll(`[data-offer-id="${item.dataset.offerId}"]`) 
    : document.querySelectorAll(`[data-offer-id]`);

    if (offerItems.length) {
      // create dict to help check if items need to be swapped
      let offerSets = [...offerItems].reduce((obj, item) => {
        let key = item.dataset.offerId;
        obj[key] = obj[key] || {};
        obj[key].qty = (obj[key].qty || 0) + +item.dataset.itemQty;
        obj[key].itemDiscounts = item.dataset.itemDiscounts;
        obj[key].discountValues = (obj[key].discountValues || []).concat([item.dataset.discountValue]);
        return obj;
      }, {});

      // check total qtys against active discounts
      for(let [offerId, cartData] of Object.entries(offerSets)) {
        let promoValuesList = cartData.itemDiscounts.split(',');
        let promoValue = promoValuesList[Math.min(cartData.qty - 1, promoValuesList.length - 1)];
        let needSwapCart = !cartData.discountValues.every(discount => discount == promoValue);
        if (needSwapCart) { //console.log('offer id: ', offerId, 'is swapping because of ', cartData);
          cartLoader();
          swapCart(offerId, promoValue);
          return;
        }
      }

      // fallback to changeCart
      if (item) changeCart(qty, item, key, false);
    }
    
    // restore submit btn
    publicAPI.selectors.btnATC.disabled = false;
  }
  

  /**
   * cart load animation & disable ATC
   */
  function cartLoader() {
    publicAPI.selectors.section.classList.add(publicAPI.classes.cartLoading);
    publicAPI.selectors.btnATC.disabled = true;
  }

  
  /**
   * reload cart or fetch drawer
   */
  function cartRefresh() {
    if (config.cartType == 'drawer') {
      window.MaxDesign.cartDrawer.fetchCart();
      updateCount();
    } else {
      location.reload.bind(window.location)();
    }
  }


  /*****************************************
   DYNAMIC CART REFRESH
  *****************************************/


  /**
   * update line item prices
   * @line {string} - line of product
   * @qty {number} - line item quantity
   */
  function updateLineItems(qty, item) {
    let product = {
      total: item.querySelector('.cartItems__prices-total'),
      compare_price: item.querySelector('.cartItems__prices--compare')
    };
    /* update line item prices */
    product.total.innerHTML = product.total.dataset.price == 0 ? publicAPI.config.free : Shopify.formatMoney(product.total.dataset.price*qty, Shopify.money_format);
    product.compare_price && (
      product.compare_price.innerHTML = Shopify.formatMoney(product.compare_price.dataset.comparePrice*qty, Shopify.money_format)
    );
  }


  /**
   * update cart count notifications
   */
  function updateCount() {
    if (publicAPI.selectors.cartCount) {
      for (let el of publicAPI.selectors.cartCount) el.textContent = publicAPI.cartData.item_count;
    }
    for (let el of publicAPI.selectors.cartIndication) {
      el.classList.toggle(publicAPI.classes.cartIndicationOn, publicAPI.cartData.item_count > 0);
      el.classList.toggle(publicAPI.classes.cartIndicationOff, publicAPI.cartData.item_count == 0);
    }
  }


  /**
   * update discount code and prices
   * @allowDiscount {boolean} - whether discount should be applied
   * @customDiscount {boolean} - whether discount is custom or not
   */
  function updateSummary(allowDiscount, customDiscount) {
    let newCart = publicAPI.cartData;
    // update discount
    let { cartDiscount, qtyDiscount, qtyDiscountIndex } = updateDiscount(newCart, allowDiscount, customDiscount);
    // update delivery
    let { deliveryAmount, deliveryTresholdMet } = updateDelivery(newCart);
    // update subtotal price
    publicAPI.selectors.price.subtotal.innerHTML = Shopify.formatMoney(newCart.original_total_price, Shopify.money_format);
    // update total price
    publicAPI.selectors.price.total.innerHTML = Shopify.formatMoney(newCart.original_total_price - cartDiscount + deliveryAmount, Shopify.money_format);
    // update savings
    updateSavings(newCart.original_total_price, cartDiscount);
    // update Message bar
    updateMessageBar(newCart, qtyDiscount, qtyDiscountIndex, deliveryTresholdMet);
  }


  /**
   * get current discount value to apply
   * @newCart {object} - new cart object
   * @allowDiscount {boolean} - whether discount should be applied
   * @customDiscount {boolean} - whether discount is custom or not
   * @return {Object} - cart total discount & params used in main function
   */
  function updateDiscount(newCart, allowDiscount = true, customDiscount) {
    let qtyDiscountIndex;
    let autoDiscount = newCart.total_discount > 0;
    let qtyDiscount = allowDiscount && !customDiscount && !autoDiscount && config.discount.qty.enabled;
    let discountValue = allowDiscount ? newCart.custom_discount || 0 : 0;
    let cartDiscount = autoDiscount ? newCart.total_discount : Math.floor(newCart.original_total_price*discountValue/100);

    // overide with qty discount if enabled
    if(qtyDiscount) {
      qtyDiscountIndex = Math.max(Math.min(newCart.item_count - 1, 3), 0);
      discountValue = +config.discount.qty.values[qtyDiscountIndex];
      cartDiscount = Math.floor(newCart.original_total_price*discountValue/100);
      publicAPI.selectors.discount.submitInput.value = config.discount.qty.codes[qtyDiscountIndex];
      publicAPI.cartData.custom_discount = +discountValue;
    }

    // update discount price & layout
    if (autoDiscount || discountValue > 0) {
      publicAPI.selectors.discount.field.classList.add(publicAPI.classes.hidePromoField);
      publicAPI.selectors.summaryDetails.classList.add(publicAPI.classes.summaryTotalDetails);
      publicAPI.selectors.discount.price.innerHTML = '- ' + Shopify.formatMoney(cartDiscount, Shopify.money_format);
      !autoDiscount && (publicAPI.selectors.discount.title.textContent = publicAPI.selectors.discount.submitInput.value);
    } else {
      config.discount.promoField && publicAPI.selectors.discount.field.classList.remove(publicAPI.classes.hidePromoField);
      publicAPI.selectors.summaryDetails.classList.remove(publicAPI.classes.summaryTotalDetails);
    }

    // return discount amount
    return {
      cartDiscount,
      qtyDiscount,
      qtyDiscountIndex
    };
  }


  /**
   * get current delivery value to apply
   * @newCart {object} - new cart object
   * @return {number} - delivery value & param used in main function
   */
  function updateDelivery(newCart) {
    let deliveryTresholdMet, deliveryAmount = 0;

    // overide delivery amount if upsell / shipping treshold enabled
    if(config.shipping.treshold || config.upsell.type == 'shipping') {
      let treshold = config.upsell.type == 'shipping' ? config.upsell.tresholdValue : config.shipping.tresholdValue;
      deliveryTresholdMet = newCart.original_total_price >= treshold;
      deliveryAmount = deliveryTresholdMet ? config.shipping.priceAfter : config.shipping.priceBefore;
      deliveryAmount = deliveryAmount.replace(/[,.]/g, '');
      // inject delivery price in DOM
      if(publicAPI.selectors.price.delivery) {
        publicAPI.selectors.price.delivery.innerHTML = isNaN(+deliveryAmount)
        ? deliveryAmount
        : Shopify.formatMoney(+deliveryAmount, Shopify.money_format);
      }
    }

    // return delivery amount
    return {
      deliveryAmount: isNaN(+deliveryAmount) ? 0 : +deliveryAmount,
      deliveryTresholdMet
    }
  }


  /**
   * update savings
   * @cartSubtotal {number} - cart original total price
   * @cartDiscount {number} - discount reduction applied in total price
   */
  function updateSavings(cartSubtotal, cartDiscount) {
    if(publicAPI.selectors.summarySavings) {
      let totalComparePriceValue = 0, savings = 0, qtyValue, comparePriceValue;

      // cumulate compare at price diff
      publicAPI.selectors.cartItems.forEach(function(item) {
        qtyValue = item.dataset.itemQty;
        comparePriceValue = item.querySelector('[data-compare-price]')
        ? item.querySelector('[data-compare-price]').dataset.comparePrice
        : item.querySelector('[data-price]').dataset.price;
        totalComparePriceValue += comparePriceValue*qtyValue;
      });

      // inject updated total savings
      savings = Math.round(cartDiscount + totalComparePriceValue - cartSubtotal);
      if (savings > 0) {
        publicAPI.selectors.price.savings.innerHTML = Shopify.formatMoney(savings, Shopify.money_format);
        publicAPI.selectors.summarySavings.classList.remove(publicAPI.classes.hideSavings);
      } else {
        publicAPI.selectors.summarySavings.classList.add(publicAPI.classes.hideSavings);
      }
    }
  }


  /**
   * update Announce Bar by priority
   * @newCart {object} - new cart object
   * @qtyDiscount {boolean} - whether qty discount is enabled
   * @qtyDiscountIndex {number} - index message based on cart count
   * @deliveryTresholdMet {boolean} - whether shipping treshold is exceeded or not
   */
  function updateMessageBar(newCart, qtyDiscount, qtyDiscountIndex, deliveryTresholdMet) {
    let msgWrapper = publicAPI.selectors.cartMessageWrapper;
    let msgEl = msgWrapper.firstElementChild;

    // > Qty discount
    if(qtyDiscount && config.discount.qty.messages[qtyDiscountIndex] != '') {
      msgEl.innerHTML = config.discount.qty.messages[qtyDiscountIndex];
      msgWrapper.classList.remove(publicAPI.classes.hideMsgBar);
      return;
    }

    // > Shipping message
    shippingMsg: if(config.shipping.treshold) {
      let tresholdTextBefore = config.shipping.tresholdTextBefore
      .replace('XX', Shopify.formatMoney(config.shipping.tresholdValue - newCart.original_total_price, Shopify.money_format))
      .replace('YY', Shopify.formatMoney(config.shipping.tresholdValue, Shopify.money_format));
      if(deliveryTresholdMet && config.shipping.tresholdTextAfter != '') {
        msgEl.innerHTML = config.shipping.tresholdTextAfter;
      } else if (!deliveryTresholdMet && config.shipping.tresholdTextBefore != '') {
        msgEl.innerHTML = tresholdTextBefore;
      } else {
        break shippingMsg;
      }
      msgWrapper.classList.remove(publicAPI.classes.hideMsgBar);
      return;
    }

    // > Cart message
    if(config.announce.enabled && config.announce.text != '') {
      msgEl.innerHTML = config.announce.text;
      msgWrapper.classList.remove(publicAPI.classes.hideMsgBar);
      return;
    }

    // > default behaviour
    msgWrapper.classList.add(publicAPI.classes.hideMsgBar);
  }


  /**
   * update upsell progress
   * @newCart {object} - updated json cart
   * @subTotal {number} - cart original total price
   */
  function updateUpsell() {
    let upsellInCart, progress, subTotal;
    let newCart = publicAPI.cartData;
    let moneyGoal = Shopify.formatMoney(config.upsell.tresholdValue - newCart.original_total_price, Shopify.money_format);

    // 1 upsell treshold for product
    // 2 upsell treshold for shipping
    if (config.upsell.type == 'product') {
      upsellInCart = Object.values(newCart.items).find( ({ variant_id }) => config.upsell.id == variant_id);
      subTotal = upsellInCart ? (newCart.original_total_price - upsellInCart.original_price) : newCart.original_total_price;
      progress = subTotal*100/config.upsell.tresholdValue;

      // check if treshold is met
      if (!upsellInCart && progress >= 100 && config.upsell.id != 0) {
        setTimeout(function() {
          config.upsell.manual && publicAPI.selectors.upsell.wrapper.classList.add(publicAPI.classes.claimUpsell);
          !config.upsell.manual && publicAPI.selectors.upsell.wrapper.classList.add(publicAPI.classes.hideProgressBar);
          publicAPI.selectors.upsell.text.innerHTML = config.upsell.textClaim;
          if(!config.upsell.manual) {
            addToCart([{"quantity": 1,"id": config.upsell.id, properties: config.upsell.prop}], cartRefresh, true);
          }
        }, 350);
      } else if (progress < 100) {
        if (upsellInCart) changeCart(0, null, upsellInCart.key);
        config.upsell.manual && publicAPI.selectors.upsell.wrapper.classList.remove(publicAPI.classes.claimUpsell);
        !config.upsell.manual && publicAPI.selectors.upsell.wrapper.classList.remove(publicAPI.classes.hideProgressBar);
        publicAPI.selectors.upsell.text.innerHTML = config.upsell.text.replace('XX', moneyGoal).replace('YY', config.upsell.tresholdValue);
      }
    } else if (config.upsell.type == 'shipping') {
      progress = newCart.original_total_price*100/config.upsell.tresholdValue;

      // check if treshold is met
      if(progress >= 100) {
        publicAPI.selectors.upsell.text.innerHTML = config.upsell.textClaim;
        publicAPI.selectors.upsell.wrapper.classList.add(publicAPI.classes.hideProgressBar);
      } else {
        publicAPI.selectors.upsell.text.innerHTML = config.upsell.text.replace('XX', moneyGoal).replace('YY', config.upsell.tresholdValue);
        publicAPI.selectors.upsell.wrapper.classList.remove(publicAPI.classes.hideProgressBar);
      }
    }

    // update progress bar
    publicAPI.selectors.upsell.progress.dataset.progress = Shopify.formatMoney(newCart.original_total_price, Shopify.money_format).replace(/<\/?[^>]+(>|$)/g, "");
    publicAPI.selectors.upsell.progress.style.width = progress + '%';
  }

})(window.MaxDesign = window.MaxDesign || {});